import { csx } from '@vtex/admin-ui'

export const styles = {
  cell: csx({
    '> div': {
      display: 'grid',
      placeContent: 'center start',
      span: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  }),
  titleContainer: csx({
    display: 'flex',
    alignItems: 'center',
    gap: '$space-2',
  }),
  tableContainer: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-5',
  }),
  fullWidth: csx({
    width: '100%',
  }),
  counter: csx({
    marginLeft: '$space-2',
    borderRadius: '0.5rem',
    paddingX: '6px',
  }),
  tagContent: csx({
    color: '$black',
  }),
  topContainer: csx({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '$space-8',
  }),
  pagination: csx({
    '&&': {
      'span[data-size="small"]': {
        width: 'auto',
      },
    },
  }),
}
